import React , {useState} from 'react';
import styles from "./checkboox.module.scss";


const name = "You are agree with our Terms & Conditions"
const CheckBox = () => {
const [Tnc , setTnc] = useState(false);
    return (
        <>
            <div className={styles.checkboxdiv}>
            <span className={styles.checkboxd}
            onChange= {(e) => setTnc(e.target.checked)}
            />
            <div className={styles.text}> {name}</div>
            </div>
        </>
    )
}

export default CheckBox;
